/** A selectable option (value/text pair) for a generic data-driven UI control such as a dropdown. */
export type DataOption = {
    value: string | number | string[],
    text: string,
    isSelected?: boolean
}

/** Configuration for replacing a text input with a custom dropdown control, including its data source and single/multi-select behavior. */
export class InputDropdownReplacementProperties {
    data!: DropdownDataOption[];
    inputSelector: any;
    dropdownId!: string;
    isMultiSelect?: boolean;
    enableOtherOption?: boolean;

    /**
     * Creates an InputDropdownReplacementProperties instance with single-select mode and no "other" option enabled by default.
     */
    constructor() {
        this.isMultiSelect = false;
        this.enableOtherOption = false;
    }
}

/** Configuration for rendering a dropdown's options as a set of individual input controls (e.g. checkboxes/radios) in a container. */
export class DropdownOptionInputsReplacementProperties {
    dropdownSelector: any;
    optionsContainerId: string;
    optionsNameId: string;
    numberOfColumns?: number;
    optionsIgnoreList?: any[];

    /**
     * Creates a DropdownOptionInputsReplacementProperties instance with default empty selectors/ids, a 4-column layout, and an empty ignore list.
     */
    constructor() {
        this.dropdownSelector = null;
        this.optionsContainerId = "";
        this.optionsNameId = "";
        this.numberOfColumns = 4;
        this.optionsIgnoreList = [];
    }
}

/** A single value/description pair representing one option of a dropdown control. */
export type DropdownDataOption = {
    value: string | number,
    description: string
}
